import { getCourseEnrolDetail } from '@/actions/courses';
import { isLogin } from '@/helpers/loginHelper';
import useWidth from '@/helpers/widthUtil';
import { Button, Modal, Skeleton, message } from 'antd';
import { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import videojs from 'video.js';
import Video from '../Video';
import VideoHLS from '../video/index';
import router from 'next/router';
import { ShoppingCartOutlined } from '@ant-design/icons';
import RequestCallForm from './RequestCallForm';
import Link from 'next/link';
import { DetailsContext } from '.';
import axios from 'axios';

const DetailsCard = () => {
  const dispatch = useDispatch();
  const {
    course,
    courseEnroll,
    auth,
    videoLoading,
    isStickyMenu,
    videoPreviewMode,
    clearPreviewState,
    courseVideo,
    videoRef,
    viewCallReqModal,
    setViewCallReqModal,
  } = useContext(DetailsContext);

  const [adPreview, setAdPreview] = useState(false);
  var discountedPrice =
    courseEnroll?.price -
    (courseEnroll?.discount_percentage / 100) * courseEnroll?.price;
  const { isMobile } = useWidth();

  useEffect(() => {
    if (typeof window !== undefined) {
      var el: any = document.querySelector('cc-nsge');
      if (el) el.style.bottom = '74px !important';
    }
  }, []);

  useEffect(() => {
    isLogin() &&
      courseEnroll?.is_enroll &&
      courseEnroll?.is_under_membership &&
      dispatch(getCourseEnrolDetail(course?.slug));
  }, [isLogin, courseEnroll]);

  const VideoPlaySection = () => (
    <div className="mt-3 mx-0">
      <div
        className={`position-relative ${
          !isMobile ? 'pl-3 pr-3' : 'text-center'
        } border-14`}
      >
        {isMobile ? (
          <img
            alt="course-preview"
            height={300}
            width="100%"
            src={
              course?.ad_video?.poster
                ? course?.ad_video?.poster
                : course?.image
                ? course?.image
                : '/images/course.webp'
            }
            style={{ minHeight: '170px' }}
          />
        ) : (
          <img
            alt="course-preview"
            // height={225}
            // width={500}
            src={
              course?.ad_video?.poster
                ? course?.ad_video?.poster
                : course?.image
                ? course?.image
                : '/images/course.webp'
            }
            style={{ height: '225px', width: '500px' }}
          />
        )}
        {course?.ad_video && (
          <div
            className="course-preview-play bg-white"
            onClick={() => {
              setAdPreview(true);
              clearPreviewState();
            }}
          >
            <i className="fas fa-play-circle" style={{ color: '#c71a23' }}></i>
          </div>
        )}
      </div>
    </div>
  );

  const StickyPriceFooter = () => (
    <div className="sticky-footer-card d-flex flex-column align-items-center justify-content-betweens">
      {course?.price &&
        courseEnroll?.discount_percentage > 0 &&
        courseEnroll?.discount_percentage < 100 &&
        !courseEnroll?.is_under_membership &&
        !courseEnroll?.is_enroll && (
          <div className="mr-2">
            <span
              className="text-dark font-weight-bold"
              style={{ fontWeight: '550' }}
            >
              {courseEnroll?.currency === 'NPR' ? 'Rs.' : '$'}
              {discountedPrice.toFixed(2)}/-
            </span>
            <del style={{ fontSize: '10px' }}>
              {courseEnroll?.currency === 'NPR' ? 'Rs.' : '$'}
              {courseEnroll?.price}/-
            </del>
          </div>
        )}
      <ButtonSection />
    </div>
  );

  return (
    <>
      <Modal
        visible={adPreview}
        title={<h6 className="font-weight-bold">Course Preview</h6>}
        onCancel={() => {
          setAdPreview(false);
          var myPlayer = videojs('learnsic-player_html5_api');
          myPlayer.pause();
        }}
        maskClosable={false}
        footer={false}
        width={850}
      >
        {!videoPreviewMode ? (
          <Video
            source={course?.ad_video?.file}
            timeoutAction={false}
            watermark={false}
            videoRef={videoRef}
          />
        ) : !videoLoading ? (
          <>
            <VideoHLS
              source={courseVideo?.file}
              timeoutAction={false}
              watermark={false}
              videoRef={videoRef}
            />
          </>
        ) : (
          <div
            className="video-js vjs-theme-forest vjs-big-play-centered"
            style={{ paddingTop: '56.25%', width: '100%' }}
          >
            <div className="videoLoading vjs-big-play-button"></div>
          </div>
        )}
      </Modal>

      <Modal
        visible={viewCallReqModal}
        title={<h6 className="font-weight-bold">Request Callback</h6>}
        onCancel={() => {
          setViewCallReqModal(false);
        }}
        maskClosable={false}
        footer={false}
        width={500}
        centered
      >
        <RequestCallForm onSuccess={() => setViewCallReqModal(false)} />
      </Modal>

      <VideoPlaySection />
      {isMobile ? (
        !isStickyMenu ? (
          <StickyPriceFooter />
        ) : (
          ''
        )
      ) : (
        <div
          className={`${isMobile ? '' : 'border border-muted'} bg-white`}
          style={{
            marginLeft: isMobile ? '' : '1rem',
            marginRight: isMobile ? '' : '1rem',
          }}
        >
          <CoursePrice />

          <div className="text-center pt-2 pl-3 pr-3 pb-3">
            <ButtonSection />
            <RequestCallSection />
          </div>
        </div>
      )}
    </>
  );
};

export default DetailsCard;

export const CoursePrice = ({ showLabel = true }) => {
  const { course, courseEnroll } = useContext(DetailsContext);

  var discountedPrice =
    courseEnroll?.price -
    (courseEnroll?.discount_percentage / 100) * courseEnroll?.price;

  return (
    course?.price &&
    courseEnroll?.discount_percentage > 0 &&
    courseEnroll?.discount_percentage < 100 &&
    !courseEnroll?.is_under_membership &&
    !courseEnroll?.is_enroll && (
      <div className="text-dark text-center d-flex flex-row justify-content-around pt-3">
        {showLabel && <div className="font-weight-bold">Course Fee</div>}
        <div>
          <span className="text-dark font-weight-bold" style={{ fontWeight: '550' }}>
            {courseEnroll?.currency === 'NPR' ? 'Rs.' : '$'}
            {discountedPrice.toFixed(2)}/-
          </span>
          <del style={{ fontSize: '10px' }}>
            {courseEnroll?.currency === 'NPR' ? 'Rs.' : '$'}
            {courseEnroll?.price}/-
          </del>
        </div>
      </div>
    )
  );
};

const CourseActionBtn = ({ name, ...props }) => {
  const { loading } = useContext(DetailsContext);

  return (
    <div className="d-flex justify-content-center">
      {loading ? (
        <Skeleton.Button active className="w-100" />
      ) : (
        <Button className="btn-secondary border-18 border-danger w-100" {...props}>
          {name}
        </Button>
      )}
    </div>
  );
};

const ContentStartButton = () => {
  const { course, courseEnroll } = useContext(DetailsContext);
  const courseContent = useSelector(
    (state: any) => state.courses?.courseEnrolDetail?.data
  );

  return (
    <CourseActionBtn
      onClick={() =>
        router.push({
          pathname: `/course/lesson/${course?.slug}/`,
          query: {
            subtab: courseContent?.last_content
              ? courseContent?.last_content?.subject
              : courseContent?.subject[0]?.id,
            chaptab: courseContent?.last_content
              ? courseContent?.last_content?.chapter
              : courseContent?.subject[0]?.chapter[0]?.id,
            activetab: courseContent?.last_content
              ? courseContent?.last_content?.id
              : courseContent?.subject[0]?.chapter[0]?.content[0]?.id,
          },
        })
      }
      name={courseEnroll?.content_started ? 'Continue Learning' : 'Start Learning'}
    />
  );
};

const BuyRenewButton = ({ isBuy }) => {
  const [messageApi, contextHolder] = message.useMessage();
  const { course, onBuyNowClick } = useContext(DetailsContext);

  const handleFreeTrial = () => {
    axios({
      method: 'POST',
      headers: {
        Authorization: `${localStorage.getItem('token')}`,
      },
      url: `${process.env.NEXT_PUBLIC_BASE_URL}course-trial/${course?.slug}/`,
      data: {
        is_preview: true,
      },
    })
      .then(() => {
        router.push(`/course/lesson/preview/${course?.slug}`);
      })
      .catch(() => {
        messageApi.error('Failed to enroll free trial.');
      });
  };

  return (
    <>
      {contextHolder}
      <CourseActionBtn
        icon={
          isBuy ? (
            <ShoppingCartOutlined
              rev=""
              className="mb-1"
              style={{ fontSize: '20px' }}
            />
          ) : (
            ''
          )
        }
        onClick={() => {
          onBuyNowClick();
          router.push({
            pathname: `/course/${course?.slug}/order`,
          });
        }}
        name={isBuy ? 'Buy Now' : 'Renew Now'}
      />
      {isBuy && (
        <div className="pt-1">
          {/* <Link href={`/course/lesson/preview/${course?.slug}`}>
            <a className="font-weight-bold mt-2">Free Trial</a>
          </Link> */}
          <div>
            <a className="font-weight-bold mt-2" onClick={handleFreeTrial}>
              Free Trial
            </a>
          </div>
        </div>
      )}
    </>
  );
};

// <<<<<<< HEAD
//             <li className="text-black">
//               <i className="las la-clock "></i> Duration:{' '}
//               <span className="text-black">{course?.duration}</span>
//             </li>
          
//             <li className="text-black">
//               <i className="las la-globe"></i> Category:{' '}
//               <span className="text-black text-capitalize ml-4">
//                 {course?.test?.name}
//               </span>
//             </li>
//             {!course.live && (
//               <li className="text-black">
//                 <i className="las la-book"></i> Lectures:{' '}
//                 <span className="text-black">{course?.lecture}</span>
//               </li>
//             )}
//             {/* {course?.enroll !== 0 ? (
//               <li className="text-black">
//                 <i className="las la-bookmark"></i> Enrolled:{' '}
//                 <span className="text-black">{course?.total_enroll}</span>
//               </li>
//             ) : (
//               ''
//             )} */}
//             {course?.price && (
//               <>
//                 {
//                   // course?.discount_percentage > 0 && course?.discount_percentage < 100 &&
//                   <>
//                     {courseEnroll?.discount_percentage > 0 &&
//                       courseEnroll?.discount_percentage < 100 &&
//                       !courseEnroll?.is_under_membership &&
//                       !courseEnroll?.is_enroll && (
//                         <li className="text-black">
//                           <i className="las la-bookmark"></i> Actual Price:{' '}
//                           <span className="text-black d-flex justify-content-between">
//                             <div className="d-flex flex-column">
//                               <div>
//                                 <del>
//                                   {courseEnroll?.currency === 'NPR' ? 'Rs.' : '$'}
//                                   {courseEnroll?.price}
//                                 </del>
//                                 <span className="text-black font-weight-bold ml-2">
//                                   {courseEnroll?.currency === 'NPR' ? 'Rs.' : '$'}
//                                   {discountedPrice.toFixed(2)}
//                                 </span>
//                               </div>
//                               {/* <Badge.Ribbon text={` ${courseEnroll?.discount_percentage}% off`} /> */}
//                               <span className="text-danger font-weight-bold ml-auto">
//                                 {courseEnroll?.discount_percentage}% off
//                               </span>
//                             </div>
//                           </span>
//                         </li>
//                       )}
//                     {auth &&
//                       !courseEnroll?.is_under_membership &&
//                       courseEnroll?.is_enroll && (
//                         <li className="text-black">
//                           <i className="las la-bookmark"></i> Renew Price:{' '}
//                           <span className="text-black font-weight-bold ml-2">
//                             {course?.currency === 'NPR' ? 'Rs.' : '$'}
//                             {(discountedPrice / 2).toFixed(2)}
//                           </span>
//                         </li>
//                       )}
//                   </>
//                   // : ''
//                 }
//               </>
//             )}
//           </ul>
//           {course?.coming_soon ? (
//             <Button
//               className="btn-danger w-100 border-danger text-white"
//               style={{ cursor: 'wait' }}
//             >
//               Coming Soon
//             </Button>
//           ) : !course?.is_free && (course?.is_enroll || courseEnroll.is_enroll) ? (
//             course.live ? (
//               <ul className="list-unstyled feature-list">
//                 <li className="text-black">
//                   <i className="las la-bookmark"></i> Live class list:{' '}
//                   <span className="text-black">
//                     <Link href={`/class-list/?course=${course.slug}`}>
//                       <a>
//                         <Button size="small">View</Button>
//                       </a>
//                     </Link>
//                   </span>
//                 </li>
//                 {course?.is_content_null ? null : courseEnroll?.is_under_membership ? ( // <div className="start-learning-btn">
//                   <Button className="btn-secondary w-100 border-danger">
//                     <Link href={`/course/lesson/${course.slug}/`}>
//                       <a>
//                         {courseEnroll?.content_started
//                           ? 'Continue Learning'
//                           : 'Start Learning'}
//                       </a>
//                     </Link>
//                   </Button>
//                 ) : (
//                   <Button
//                     className="btn-secondary w-100 border-danger  text-hover-danger"
//                     onClick={onBuyNowClick}
//                   >
//                     <Link href={`/course/${course?.slug}/order`}>
//                       <a>Renew now</a>
//                     </Link>
//                   </Button>
//                 )}
//               </ul>
//             ) : courseEnroll?.is_under_membership ? (
//               <Button className="btn-secondary w-100 border-danger">
//                 <Link href={`/course/lesson/${course.slug}/`}>
//                   <a>
//                     {courseEnroll?.content_started
//                       ? 'Continue Learning'
//                       : 'Start Learning'}
//                   </a>
//                 </Link>
//               </Button>
//             ) : (
//               <Button
//                 className="btn-secondary w-100 border-danger  text-hover-danger"
//                 onClick={onBuyNowClick}
//               >
//                 <Link href={`/course/${course?.slug}/order`}>
//                   <a>Renew now</a>
//                 </Link>
//               </Button>
//             )
//           ) : auth ? (
//             course?.is_free ? (
//               loading ? (
//                 <Skeleton.Button className="w-100" />
//               ) : (
//                 <Button
//                   className="btn-secondary w-100 border-danger"
//                   onClick={() => addEnroll()}
//                 >
//                   Enroll Now
//                 </Button>
//               )
//             ) : loading ? (
//               <Skeleton.Button className="w-100" />
//             ) : (
//               <Button
//                 className="btn-secondary w-100 border-danger  text-hover-danger"
//                 onClick={onBuyNowClick}
//               >
//                 <Link href={`/course/${course?.slug}/order`}>
//                   <a>Buy Now</a>
//                 </Link>
//               </Button>
//             )
//           ) : loading ? (
//             <Skeleton.Button className="w-100" />
// =======
const EnrollButton = () => {
  const { addEnroll } = useContext(DetailsContext);

  return (
    <CourseActionBtn
      onClick={() => {
        addEnroll();
      }}
      name={'Enroll Now'}
    />
  );
};

const SignUpForTrialButton = ({ isFree = false }) => {
  const { ModalLoginOpen } = useContext(DetailsContext);

  return (
    <CourseActionBtn
      onClick={() => {
        ModalLoginOpen();
      }}
      name={isFree ? 'Sign Up' : 'Sign Up For Free Trial'}
    />
  );
};

const MemberShipCondition = () => {
  const { course, courseEnroll } = useContext(DetailsContext);

  return (
    <>
      {course?.is_under_membership || courseEnroll?.is_under_membership ? (
        <ContentStartButton />
      ) : (
        <BuyRenewButton isBuy={false} />
      )}
    </>
  );
};

export const ButtonSection = () => {
  const { course, courseEnroll, auth } = useContext(DetailsContext);

  return (
    <>
      {course?.coming_soon ? (
        <CourseActionBtn name="Coming Soon" style={{ cursor: 'wait' }} />
      ) : !course?.is_free && (course?.is_enroll || courseEnroll.is_enroll) ? (
        <MemberShipCondition />
      ) : auth ? (
        course?.is_free ? (
          courseEnroll?.is_enroll || course?.is_enroll ? (
            <ContentStartButton />
// >>>>>>> testing
          ) : (
            <EnrollButton />
          )
        ) : (
          <BuyRenewButton isBuy={true} />
        )
      ) : course?.is_free ? (
        <SignUpForTrialButton isFree={true} />
      ) : (
        <SignUpForTrialButton />
      )}
    </>
  );
};

export const RequestCallSection = () => {
  const { setViewCallReqModal, auth } = useContext(DetailsContext);

  return (
    <>
      {!auth && (
        <>
          {/* <div className="my-2" style={{ borderBottom: '1px solid #f0f0f0' }} /> */}
          <div
            className="text-primary cursor-pointer mt-2"
            onClick={() => setViewCallReqModal(true)}
          >
            <i
              className="fa fa-phone-volume"
              style={{ fontSize: '1rem', transform: 'rotate(307deg)' }}
            ></i>{' '}
            Need Help? Request a Call
          </div>
        </>
      )}
    </>
  );
};
